/**
 * What an access token says about its holder, read in the browser.
 *
 * Only ever a reading, never a check: the signature is the server's to verify,
 * and a token this cannot read answers nothing rather than throwing.
 */
export function readTokenClaims(token: string): Record<string, unknown> | null {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    const claims: unknown = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    return claims && typeof claims === 'object' && !Array.isArray(claims)
      ? (claims as Record<string, unknown>)
      : null;
  } catch {
    return null;
  }
}

/** The role a token was signed with, or null when it names none. */
export function tokenRole(token: string): string | null {
  const role = readTokenClaims(token)?.role;
  return typeof role === 'string' ? role : null;
}

/** The person a token was signed for, or null when it names nobody. */
export function tokenSubject(token: string): string | null {
  const sub = readTokenClaims(token)?.sub;
  return typeof sub === 'string' ? sub : null;
}
